(function() {
  'use strict';

  angular
    .module('admin.users.details.comments', [])
    .controller('CommentsAdminCtrl', CommentsAdminCtrl);

  /** @ngInject */
  function CommentsAdminCtrl($scope, $stateParams, UsersService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.totalUsers = 0;
    vm.usersPerPage = 25;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1
    };

    vm.sortType = '';
    vm.sortReverse = false;

    load(1);

    var oldSortType;
    function load(pageNumber){
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }

      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }

      oldSortType = angular.copy(vm.sortType);
      UsersService.listComments($stateParams.parentId, vm.oldPage, 25, vm.sortType).then(success);

      function success(result){
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        for (var i = 0; i < result.results.length; i++) {
          result.results[i].ts = new Date(parseInt(result.results[i].ts.toString().substring(0, result.results[i].ts.toString().length - 3)));
        }

        vm.sortType = oldSortType;
        vm.items = result.results;
      }
    }

    vm.pageChanged = function(newPage) {
      vm.sortType = oldSortType;
      load(newPage);
    };

    vm.hide = function(item){
      UsersService.commentHide(item.id).then(function(){
        vm.sortType = oldSortType;
        load(vm.pagination.current);
      });
    };

    vm.sort = function(type){
      vm.sortReverse = !vm.sortReverse;
      if (vm.sortReverse) {
        vm.sortType = type + '-asc';
      } else {
        vm.sortType = type + '-desc';
      }
      load(vm.pagination.current);
    };

  }

})();
